import { List, ListItem, ListItemText, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PropTypes from 'prop-types';
import React from 'react';

const styles = {
    root: {
        maxHeight: '60vh'
    },
    listItem: (theme) => ({
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.background.default
        }
    })
};

function NotificationList({
    notifications,
    onClickNotification,
    className,
    ...rest
}) {

    const getTitle = (event, Title) => {
 
          var Deger = Title;
          return <Typography color="primary" variant="h6">
            {Deger}
          </Typography>;
  
    }
    return (
        <List
            {...rest}
            className={className}
            sx={styles.root}
            disablepadding
        >
            {notifications.map((notification, i) => (
                <ListItem
                    sx={styles.listItem}
                    divider={i < notifications.length - 1}
                    key={notification.ID}
                    onClick={() => onClickNotification(notification)}
                >
                    <ListItemText
                        primary={getTitle(notification, notification.Title)}
                        primaryTypographyProps={{ variant: 'body1' }}
                        secondary={
                            <React.Fragment>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    sx={styles.inline}
                                    color="textPrimary"
                                >
                                    {notification.Body}
                                </Typography>
                            </React.Fragment>
                        }
                    />
                    <ArrowForwardIcon sx={styles.arrowForwardIcon} />
                </ListItem>
            ))}
        </List>
    );
}

NotificationList.propTypes = {
    className: PropTypes.string,
    notifications: PropTypes.array.isRequired,
    onClickNotification: PropTypes.func
};

export default NotificationList;
